var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.overlayVisible)?_c('div',{staticClass:"overlay-loader"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Text Centered"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }